import * as React from 'react';
import { AppUser } from 'Src/views/App/App';
import { Report } from 'Src/models/report';
import { Point } from 'Src/models/venue';
import { EventAvailabilityResponses } from 'Src/components/EventAvailabilityResponses/EventAvailabilityResponses';

interface Props {
  reports: Report[];
  user: AppUser;
  onViewMapClick: (point: Point) => void;
  onEditReport?: (report: Report) => void;
}

export const ChildrenEventAvailabilityReportsSummaryTab: React.FC<Props> = props => (
  <EventAvailabilityResponses {...props} />
);

ChildrenEventAvailabilityReportsSummaryTab.displayName = 'ChildrenEventAvailabilityReportsSummaryTab';
